import React, { ReactElement } from 'react';
import './rssLink.scss';
import { Link } from 'idsk-react-components';
import iconRss from '../../../../assets/images/icon-rss.svg';

interface Props {
  to: string;
}

const RssLink = ({
  to,
}: Props): ReactElement => (
  <Link
    className="rss-link"
    to={to}
    size="extra-small"
    target="_blank"
  ><img className="rss-icon" src={iconRss} alt="ikona rss" /> RSS
  </Link>
);

export default RssLink;
